import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {
    Box,
    Grid,
} from '@mui/material';
import Select from '@mui/material/Select';
import { uuid } from './util';
import { getValidStatesProvinces } from 'features/validation';
import TitleService from 'title-service';

export default function RedQuickDropdown(props: any) {
    const [id, setId] = React.useState(uuid());
    return (
        <Box sx={{ p: 2 }}>
            <Grid item xs={12} sm={12} lg={12} sx={{ pt: { xs: 2, sm: '0 !important' } }}>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                    <InputLabel id={`label-${id}`}>{props.title}</InputLabel>
                    <Select
                        labelId={`label-${id}`}
                        id={`select-${id}`}
                        value={props.value}
                        onChange={(evt) => {
                            props.onChange(evt.target.value);
                        }}
                        label={props.title}
                    >
                        {props.options.map((op: any, index: number) => {
                            return <MenuItem value={op.value}>{TitleService(op.label)}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
        </Box>
    );
}

export function RedQuickStateProvince(props: any) {
    const [id, setId] = React.useState(uuid());
    return (
        <Grid item xs={12} sm={12} lg={12} sx={{ pt: { xs: 2, sm: '0 !important' } }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id={`label-${id}`}>{props.title}</InputLabel>
                <Select
                    labelId={`label-${id}`}
                    id={`select-${id}`}
                    value={props.value}
                    onChange={(evt) => {
                        props.onChange(evt.target.value);
                    }}
                    label={props.title}
                >
                    {getValidStatesProvinces().map((op: any, index: number) => {
                        return <MenuItem value={op}>{TitleService(op)}</MenuItem>
                    })}
                </Select>
            </FormControl>
        </Grid>
    );
}
